import { ViewerController } from '@/router/routes/viewer';
import { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/sso/signin',
    name: 'sso-signin',
    component: () => import('@/components/sso/SsoSignInPage.vue'),
  },
  ViewerController,
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('@/components/layouts/UnauthorizedPage.vue'),
  },
  {
    path: '/not-found',
    name: 'not-found',
    component: () => import('@/components/layouts/NotFoundPage.vue'),
  },
];
